import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloudUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24 42V22M24 22L18 28M24 22L30 28M14 33.6368C9.39271 32.4148 6 28.2493 6 23.2986C6 18.4002 9.6 13.875 15 13C16.6939 8.97275 20.7028 6 25.3785 6C31.3681 6 36.2634 10.645 36.6 16.5C39.7786 17.8898 42 21.3006 42 24.9937C42 29.6295 38.5 33.4472 34 33.945",
		stroke: "#7B7B7B",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCloudUpload;
